<template>
  <div>
		<dv-border-box-12 class="padding-lr-sm padding-bottom-lg margin-top-xs realTimeBox">
			<SecondTitle :secTitle="secTitle"></SecondTitle>
			<!-- :autoplay="true" :loop="true" -->
			<el-carousel direction="vertical" :interval="30000" indicator-position="none" class="elBox">
			    <el-carousel-item v-for="item in 3" :key="item" class="elBoxItem">
				  <div class="flex align-center justify-start margintbsm" v-for="(item,index) in warningRanking" :key="index">
				  	<div class="flex justify-center align-center text-cyan text-lg margin-right-sm rankIndex">
				  		{{index + 1}}
				  	</div>
				  	<div class="flex flex-direction" style="width:60%">
				  		<div class="flex align-center margin-bottom-xs">
				  			<div class="padding-lr-sm flex align-center justify-center text-xsss margin-right-sm realTimeCity">
								{{item.cityName}}
				  			</div>
				  			<div class="rankText">
				  				<span class="text-xsss margin-right-xs">预警事件数</span>{{item.alarmNum}}
				  			</div>
				  		</div>
				  		<el-progress :percentage="item.alarmNum" :show-text="false" :format="false"></el-progress>
				  	</div>
				  </div>
			    </el-carousel-item>
			</el-carousel>
		</dv-border-box-12>
  </div>
</template>

<script>
import SecondTitle from '../secondTitle.vue';
import { dataInterface } from '@/api/dataInterfaceApi';
import { Progress, Carousel ,CarouselItem} from 'element-ui'
export default {
  data () {
    return {
      secTitle:{
        title:'城市预警排名'
      },
	  warningRanking :[],  // list
    };
  },
  components: {
    SecondTitle,
    ElProgress:Progress,
    ElCarousel:Carousel,
    ElCarouselItem:CarouselItem
  },
  props: {
    
  },
  watch: {
		
  },
  mounted () {
    
  },
  methods: {
    getData(data){
      this.selectCityEarlyWarningRanking(data);
    },
    selectCityEarlyWarningRanking(data={}){
      let _this = this;
      let params = {};
      if(data){
				params = {
					"enCode":"TiDB-shengshiqu-chengshiyujingpaiming",
    			"@province":data.province||data.city||data.district
				}
			}else {
				params = {
					"enCode":"TiDB-quanguo-chengshiyujingpaiming"//TiDB-全国-城市预警排名
				}
			}
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if(!res) return;
  		  this.warningRanking = res;
        })
        .catch((err) => {
          console.log(err);
        });
    }, 
  }
}
</script>
<style lang="scss" scoped>
.elBox{
	height:330px
}
.elBoxItem{
	height:330px
}
.margintbsm{
	margin-top: 15px;
	margin-bottom: 15px;
}
.realTimeBox{
	width: 463px;
}
.realTimeList{
	width: 423px;
	height: 418px;
}
</style>